import { Button, Form, Input, InputNumber } from 'antd'
import { AttachmentUpload } from '@/features/files/index.ts'
import { formatAmount } from '@/utils/money.ts'
import type { MoneyAllocationRow } from './money-entry.types.ts'
import { toCents } from './utils/money.ts'

export function MoneyAllocationFields({
  rows,
  refund,
  includedIds,
  onToggle,
  paymentLabel = '收款',
  disabled = false
}: {
  rows: MoneyAllocationRow[]
  refund: boolean
  includedIds?: number[]
  onToggle?: (id: number, included: boolean) => void
  paymentLabel?: string
  disabled?: boolean
}) {
  const includedSet = includedIds ? new Set(includedIds) : undefined
  return rows.map((row, index) => {
    const noBalance = toCents(row.maximum) === BigInt(0)
    if (includedSet && !includedSet.has(row.billId)) {
      return (
        <div
          key={row.billId}
          className="border-border text-content-muted mb-3 flex items-center justify-between gap-3 rounded border border-solid p-3"
        >
          <span>
            {row.label} · {noBalance ? '已结清，无需收付款' : '本次已移出'}
          </span>
          <Button size="small" disabled={disabled || noBalance} onClick={() => onToggle?.(row.billId, true)}>
            重新加入
          </Button>
        </div>
      )
    }
    return (
      <div key={row.refundOfAllocationId ?? row.billId} className="border-border mb-3 rounded border border-solid p-3">
        <div className="mb-3 flex items-center justify-between gap-3 font-medium">
          <span>
            {row.label} · {refund ? '原分配可退' : '当前待结算'} ¥{formatAmount(row.maximum)}
          </span>
          {onToggle && (
            <Button size="small" disabled={disabled} onClick={() => onToggle(row.billId, false)}>
              移出本次{paymentLabel}
            </Button>
          )}
        </div>
        <div className="grid gap-x-4 sm:grid-cols-2">
          <Form.Item
            name={['rows', index, 'amount']}
            label={`本次${paymentLabel}金额`}
            rules={
              includedIds
                ? [
                    { required: true, message: `请填写本次${paymentLabel}金额，未付款请移出` },
                    {
                      validator: (_, value: string | undefined) =>
                        !value || (toCents(value) > BigInt(0) && toCents(value) <= toCents(row.maximum))
                          ? Promise.resolve()
                          : Promise.reject(new Error('金额须大于 0，且不超过当前待结算金额'))
                    }
                  ]
                : undefined
            }
            extra={noBalance ? '无待结算金额，本次不分配' : undefined}
          >
            <InputNumber
              stringMode
              precision={2}
              min="0"
              max={row.maximum}
              disabled={disabled || noBalance}
              className="w-full!"
            />
          </Form.Item>
          <Form.Item name={['rows', index, 'note']} label="备注">
            <Input maxLength={5000} />
          </Form.Item>
        </div>
        {!refund && (
          <Form.Item
            name={['rows', index, 'attachmentIds']}
            label="本账单截图／回单"
            extra="查看时与共同截图／回单合并显示"
          >
            <AttachmentUpload purpose="moneyAttachment" maxCount={30} disabled={disabled} />
          </Form.Item>
        )}
      </div>
    )
  })
}
